<template>
	<div class="type-helper">
		<table>
			<tr>
				<td style="width:35px; vertical-align: top;">
					<v-icon>
						mdi-help-circle-outline
					</v-icon>
				</td>
				<td>
					A person specification is a description of the qualifications, skills, experience, knowledge and other attributes which an employee or candidate must possess to perform successfully in the position. A person specification is often
					used during the recruitment process to find the right candidate and then used as a reminder during the performance review to ensure qualifications and other attributes have remained current once employed.
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		}
	};
</script>

<style scoped>
	.type-helper {
		font-size: 14px;
		text-align: left;
		margin-bottom: 40px;
		margin-top: 10px;
		color: rgba(0, 0, 0, 0.54);
	}
</style>
